import React from 'react';
import CheckOrCross from '../../Shared/CheckOrCross';

const BASIC_GLOBAL_VOICE_FEATURE_KEY = 'basic-global-voice';

const globalBasicVoiceFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <CheckOrCross
      key={pkg?.code}
      isCheck={pkg?.features?.includes(BASIC_GLOBAL_VOICE_FEATURE_KEY)}
    />
  ));

export default globalBasicVoiceFeatures;
